import {
  createContext,
  type ReactElement,
  type ReactNode,
  useContext,
  useRef,
  type RefObject,
} from 'react'

export interface PageHeaderContextType {
  headerRef: RefObject<HTMLElement | null>
}

export const PageHeaderContext = createContext<PageHeaderContextType | undefined>(undefined)

// Custom hook for easy consumption
export function usePageHeader(): PageHeaderContextType {
  const context = useContext(PageHeaderContext)

  if (!context) {
    throw new Error('usePageHeader must be used within PageHeaderContext.Provider')
  }

  return context
}

interface PageHeaderProviderProps {
  children: ReactNode
}

export function PageHeaderProvider({ children }: PageHeaderProviderProps): ReactElement {
  const headerRef = useRef<HTMLElement | null>(null)

  return <PageHeaderContext.Provider value={{ headerRef }}>{children}</PageHeaderContext.Provider>
}
